export const appVersion = 'v0.1.0-bec90c6';
